<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sa_name"
      placeholder="输入活动名称关键字查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.ss_uid"
        :to="'/open/crm/activity/sign?uid=' + item.activity.sa_uid"
      >
        <div class="weui-cell__bd">
          <p>{{ item.activity.sa_name }}</p>
          <p class="list-item-muted">{{ item.ss_signtime }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.activity.sa_organizer }}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";
import Finger from "@/util/finger.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/open/crm/activity/sign_list",
      clientId: null,
      filters: [
        {
          type: "date",
          name: "ss_signtime",
        }
      ],
    };
  },
  computed: {
    extraParams() {
      return { clientId: this.clientId };
    },
  },
  mounted() {
    var me = this, clientId = me.$route.params.clientId || me.$route.query.clientId;
    if (!clientId) {
      clientId = Finger.get();
    }
    me.clientId = clientId;
  }
};
</script>